'use strict';

// filter to display date as UTC timezone, example: '2023-08-01T00:00:00.000Z' | dateUTC

angular.module('filters.dateUTC', [])

.filter('dateUTC', ['$filter', function ($filter) {
    return (date) => {
      if (!date) {
        return ''
      }

      const dateParsed = date.substring(0, 10);

      return $filter('date')(dateParsed, 'longDate');
    }
}]);
